import { createTheme } from '@mantine/core'

import { ActionIcon, Button } from './components'

export const componentsTheme = createTheme({
  components: { Button, ActionIcon }
})
